import { TButtonType } from '@r1-frontend/ui-react/components/buttons/button';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const getHoveringBgColorByType = (type: TButtonType): COLORS | string => {
    switch (type) {
        case 'action':
            return COLORS.Error;
        case 'primary':
            return COLORS.GRAY_DARK;
        case 'secondary':
            return '#EFF3F7';
        case 'white':
            return '#F2F2F2';
        case 'accent':
            return COLORS.ButtonAccent;
        case 'ghost':
            return COLORS.transparent;
    }
};

export default getHoveringBgColorByType;
